<template>
  <div class="content2">
    <vue-headful
    title="Dashboard | Divorce Settlement Agreement"
    description="Dashboard | Divorce Settlement Agreement"
/>

<div v-if="propsdata[0].loading_documents" class="loader" style="margin: 250px auto;">
  <div>
    <ul>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
    </ul>
  </div><span>Loading</span>
</div>


    <div v-if="!propsdata[0].loading_documents" class="sc-bvTASY jPMoWD">

             <div v-if="propsdata[0].documents !== null" class="sc-cFlXAS WflZx">
               <div class="row">
                <div class="col-md-12 col-lg-6-franco mb-4" v-for="(divorcesettlement, num) in propsdata[0].documents">
                  <div class="pricing-card">
                  <div class="card shadow-soft border-light">
                  <div class="row no-gutters align-items-center">
                   <div class="col-sm-6">
                     <header class="card-header text-center">
                       <span class="d-block my-2">
                         <img @click="document_number(num)" data-toggle="modal" data-target="#modal-default" src="https://documentify.com/images/preview-divorce-settlement-agreement.jpg" class="sc-cmIlrE haTfuX" style="cursor: initial;background-repeat: no-repeat;background-size: contain;background-position: center center;width: initial;height: 100%;max-height: 365px;">
                       </span>
                       </header>
                   </div>
                   <div class="col-sm-6 elpaddingdelmobileversion" style="padding-top: 20px;padding-bottom: 20px;">
                     <div class="sc-dBaXSw hCpORs">
                        <div class="sc-ccLTTT fBHvCq">
                           <div class="sc-hlILIN cLFOMf">
                              <div class="sc-jQMNup eRizKN">
                                <a @click="lapicito(num)" v-if="numeroedit !== num" class="sc-bJHhxl kkRCtf">{{divorcesettlement.titulo}}</a>
                               <div v-if="edit && numeroedit === num" v-click-outside="hide">
                                <input v-model="divorcesettlement.titulo" @keyup='edittitulo(num)' @keyup.enter='hide' type="text" placeholder="Untitled" style="background: transparent;border: transparent;outline: none;border-bottom: 2px solid #0949b3;color:#515151;width: 169px;padding: 0;font-weight: 300;" autofocus="autofocus" onfocus="this.select()">
                               </div>
                                <div @click="lapicito(num)" v-if="numeroedit !== num" class="sc-gAmQfK gQXEKA">
                                   <div class="sc-hwwEjo leOORe">
                                      <div class="sc-hAXbOi jxPiur simptip-position-top simptip-smooth" data-tooltip="Rename">
                                         <svg width="24" height="24" style="margin-bottom: 10px;" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"></path>
                                         </svg>
                                      </div>
                                   </div>
                                </div>
                              </div>
                              <div in="exited" class="sc-dphlzf hsJJHO"></div>
                           </div>
                        </div>
                        <div class="sc-bNQFlB jaiNr">
                           <div class="sc-hizQCF dXstwa">Updated {{divorcesettlement.datetime}}</div>
                        </div>
                        <div style="display:flex; margin-bottom:12px;">
                          <a :href="'/divorce-settlement-agreement-generator/'+divorcesettlement.unique_id">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Edit</div>
                           </a>
                        </div>
                        <div style="display:flex; margin-bottom:12px;">
                          <a class="preview_btnhover" @click="document_number(num)" data-toggle="modal" data-target="#modal-default">
                           <div style="display: inline;">
                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="22" height="22" fill="#0949b3" style="margin-right: 2px;">
                               <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
                             </svg>
                           </div>
                           <div style="display: inline;">Preview</div>
                         </a>
                        </div>
                        <div style="display:flex; margin-bottom:12px;">
                          <a v-if="propsdata[0].email !== '' && (propsdata[0].paid === 'yes' || divorcesettlement.one_time_payment === 'yes')" :href="'/divorce-settlement-agreement-pdf/'+divorcesettlement.unique_id" download>
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9,6 L9,13 L7.20376823,13 L12,18.4814077 L16.7962318,13 L15,13 L15,6 L9,6 Z M7,11 L7,5 C7,4.44771525 7.44771525,4 8,4 L16,4 C16.5522847,4 17,4.44771525 17,5 L17,11 L19,11 C19.8591588,11 20.3183367,12.0119217 19.7525767,12.6585046 L12.7525767,20.6585046 C12.3541654,21.1138318 11.6458346,21.1138318 11.2474233,20.6585046 L4.24742331,12.6585046 C3.68166327,12.0119217 4.14084119,11 5,11 L7,11 Z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Download PDF</div>
                           </a>
                          <a v-else-if="propsdata[0].email !== '' && (propsdata[0].paid !== 'yes' && divorcesettlement.one_time_payment !== 'yes')" :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_download_pdf'">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9,6 L9,13 L7.20376823,13 L12,18.4814077 L16.7962318,13 L15,13 L15,6 L9,6 Z M7,11 L7,5 C7,4.44771525 7.44771525,4 8,4 L16,4 C16.5522847,4 17,4.44771525 17,5 L17,11 L19,11 C19.8591588,11 20.3183367,12.0119217 19.7525767,12.6585046 L12.7525767,20.6585046 C12.3541654,21.1138318 11.6458346,21.1138318 11.2474233,20.6585046 L4.24742331,12.6585046 C3.68166327,12.0119217 4.14084119,11 5,11 L7,11 Z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Download PDF</div>
                           </a>
                          <a v-if="propsdata[0].email === ''" @click="$emit('open_modal_signup', divorcesettlement.unique_id)" class="downloads_btnhover">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9,6 L9,13 L7.20376823,13 L12,18.4814077 L16.7962318,13 L15,13 L15,6 L9,6 Z M7,11 L7,5 C7,4.44771525 7.44771525,4 8,4 L16,4 C16.5522847,4 17,4.44771525 17,5 L17,11 L19,11 C19.8591588,11 20.3183367,12.0119217 19.7525767,12.6585046 L12.7525767,20.6585046 C12.3541654,21.1138318 11.6458346,21.1138318 11.2474233,20.6585046 L4.24742331,12.6585046 C3.68166327,12.0119217 4.14084119,11 5,11 L7,11 Z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Download PDF</div>
                           </a>
                        </div>
                        <div style="display:flex; margin-bottom:12px;">
                          <a v-if="propsdata[0].email !== '' && (propsdata[0].paid === 'yes' || divorcesettlement.one_time_payment === 'yes')" :href="'/divorce-settlement-agreement-docx/'+divorcesettlement.unique_id">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17 19V7.82843L14.1716 5H7v14h10zm1 2H6c-.55228 0-1-.4477-1-1V4c0-.55228.44772-1 1-1h8.5858c.2652 0 .5196.10536.7071.29289l3.4142 3.41422c.1875.18753.2929.44189.2929.7071V20c0 .5523-.4477 1-1 1z M10.5169 12.8175L9.66292 10H8l1.75281 5h1.30339L12 12.2222 12.9438 15h1.3034L16 10h-1.6629l-.854 2.8175L12.5393 10h-1.0786l-.9438 2.8175z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Download DOCX</div>
                           </a>
                          <a v-else-if="propsdata[0].email !== '' && (propsdata[0].paid !== 'yes' && divorcesettlement.one_time_payment !== 'yes')" :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_download_docx'">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17 19V7.82843L14.1716 5H7v14h10zm1 2H6c-.55228 0-1-.4477-1-1V4c0-.55228.44772-1 1-1h8.5858c.2652 0 .5196.10536.7071.29289l3.4142 3.41422c.1875.18753.2929.44189.2929.7071V20c0 .5523-.4477 1-1 1z M10.5169 12.8175L9.66292 10H8l1.75281 5h1.30339L12 12.2222 12.9438 15h1.3034L16 10h-1.6629l-.854 2.8175L12.5393 10h-1.0786l-.9438 2.8175z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Download DOCX</div>
                           </a>
                          <a v-if="propsdata[0].email === ''" @click="$emit('open_modal_signup', divorcesettlement.unique_id)" class="downloads_btnhover">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17 19V7.82843L14.1716 5H7v14h10zm1 2H6c-.55228 0-1-.4477-1-1V4c0-.55228.44772-1 1-1h8.5858c.2652 0 .5196.10536.7071.29289l3.4142 3.41422c.1875.18753.2929.44189.2929.7071V20c0 .5523-.4477 1-1 1z M10.5169 12.8175L9.66292 10H8l1.75281 5h1.30339L12 12.2222 12.9438 15h1.3034L16 10h-1.6629l-.854 2.8175L12.5393 10h-1.0786l-.9438 2.8175z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Download DOCX</div>
                           </a>
                        </div>
                        <div style="display:flex; margin-bottom:12px;">
                          <a v-if="propsdata[0].email !== '' && (propsdata[0].paid === 'yes' || divorcesettlement.one_time_payment === 'yes')" :href="'/divorce-settlement-agreement-pdf/'+divorcesettlement.unique_id">
                           <div style="display: inline;">
                             <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-printer" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#0949b3" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"></path>
                                <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path>
                                <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Print</div>
                           </a>
                          <a v-else-if="propsdata[0].email !== '' && (propsdata[0].paid !== 'yes' && divorcesettlement.one_time_payment !== 'yes')" :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_download_print'">
                           <div style="display: inline;">
                             <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-printer" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#0949b3" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"></path>
                                <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path>
                                <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Print</div>
                           </a>
                          <a v-if="propsdata[0].email === ''" @click="$emit('open_modal_signup', divorcesettlement.unique_id)" class="downloads_btnhover">
                           <div style="display: inline;">
                             <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-printer" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#0949b3" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"></path>
                                <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path>
                                <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z"></path>
                             </svg>
                           </div>
                             <div style="display: inline;">Print</div>
                           </a>
                        </div>
                        <div style="display:flex; margin-bottom:12px;">
                          <a @click="el_sure(num)" class="delete_btnhover">
                           <div style="display: inline;">
                             <svg width="24" height="24" viewBox="0 0 24 24" fill="#ee5150" version="1.1" xmlns="http://www.w3.org/2000/svg">
                               <path d="M8,19 L16,19 L16,13 L8,13 L8,19 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,3 L16,3 L16,7 Z M14,7 L14,5 L10,5 L10,7 L14,7 Z M6,11 L18,11 L18,21 L6,21 L6,11 Z" fill-rule="nonzero"></path>
                             </svg>
                           </div>
                           <div style="display: inline;">Delete</div>
                         </a>
                        </div>
                        <p v-if="sure && numerosure === num">Are you sure? <a @click="delete_draft(num)" style="color:#5dba00;">YES</a> / <a @click="el_sure(num)" style="color:#ee5150;">NO</a></p>
                        <a v-if="divorcesettlement.one_time_payment === 'yes'" class="btn btn-md btn-pricing-plan" style="color: #26b768; background-color: rgb(255, 255, 255); border-color: #26b768; cursor: initial;">
                        One Time Purchase
                        </a>
                        <!-- <div class="sc-hARARD dHZVB">
                           <div style="display:flex; margin-bottom:12px;">
                              <div style="display: inline;">
                                 <svg width="24" height="24" viewBox="0 0 24 24" fill="#0949b3" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.5,14 C5.67157288,14 5,13.3284271 5,12.5 C5,11.6715729 5.67157288,11 6.5,11 C7.32842712,11 8,11.6715729 8,12.5 C8,13.3284271 7.32842712,14 6.5,14 Z M12.5,14 C11.6715729,14 11,13.3284271 11,12.5 C11,11.6715729 11.6715729,11 12.5,11 C13.3284271,11 14,11.6715729 14,12.5 C14,13.3284271 13.3284271,14 12.5,14 Z M18.5,14 C17.6715729,14 17,13.3284271 17,12.5 C17,11.6715729 17.6715729,11 18.5,11 C19.3284271,11 20,11.6715729 20,12.5 C20,13.3284271 19.3284271,14 18.5,14 Z"></path>
                                 </svg>
                              </div>
                              More
                           </div>
                        </div> -->
                     </div>
                   </div>
                </div>
                </div>
                </div>
                </div>
              </div>
            </div>


<div v-if="propsdata[0].documents === null || propsdata[0].documents.length === 0" class="padding_dsp_de_1435">
<div class="sc-hcnlBt kVTXUr" style="max-width: 1120px;margin: 0 auto;">
  <div type="resumes" class="sc-hkbPbT jPHylE"></div>
  <h2 class="sc-jRhVzh exltuq">Create Legal Divorce Settlement Agreement</h2>
  <p class="sc-iHhHRJ iUpXMa">Outlines the terms of the divorce, including the division of assets, child custody, and support arrangements, and is legally binding once signed by both parties.</p>
  <a href="/generate-divorce-settlement-agreement" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255);display:initial!important;"><svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
  Create Divorce Settlement Agreement Now</a>
</div>
</div>

<!-- MODAL -->
<div v-if="propsdata[0].documents !== null" class="modal fade" id="modal-default" tabindex="-1" role="dialog" aria-labelledby="modal-default" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 850px;height: -webkit-fill-available;">
        <div class="modal-content modal-content-enmobile" style="height: -webkit-fill-available;">
            <div class="modal-header">
                <h6 class="modal-title">Document Preview</h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body document_preview" style="overflow: hidden auto; margin: 20px; border: 1px solid rgb(204, 204, 204); padding: 0;">
              <img class="card-img-top profile-image-small mb-2" src="/preview/divorce-settlement-agreement-1.jpg" alt="Preview Divorce Settlement Agreement">
              <img class="card-img-top profile-image-small mb-2" src="/preview/divorce-settlement-agreement-2.jpg" alt="Preview Divorce Settlement Agreement">
              <img class="card-img-top profile-image-small" src="/preview/divorce-settlement-agreement-3.jpg" alt="Preview Divorce Settlement Agreement">
            </div>
            <div>
              <div role="alert" class="alert alert-secondary alert-dismissible fade show mb-0 classdefranco" style="border-radius: 0px;display: flex;justify-content: space-between;background-color: #1266c9;border-color: #1266c9;">
                <span class="alert-inner--text textoenmobilemodal" style="font-size: 18px; line-height: 42px;">This is just a sample. Download it now to see your document all filled.</span>
                <a v-if="propsdata[0].paid === 'yes' || propsdata[0].documents[document_preview].one_time_payment === 'yes'" :href="'/divorce-settlement-agreement-pdf/'+propsdata[0].documents[document_preview].unique_id" class="btn btn-white btn_del_continue" download>Download</a>
                <a v-else-if="propsdata[0].paid !== 'yes' && propsdata[0].documents[document_preview].one_time_payment !== 'yes'" :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_preview_modal'" class="btn btn-white btn_del_continue">Download</a>
              </div>
            </div>
        </div>
    </div>
</div>

  </div>

  </div>

</template>

<style>
a {
  color: #515151;
}
.delete_btnhover:hover{
  color: #ee5150!important;
}
.preview_btnhover:hover{
  color: #073482!important;
}
.downloads_btnhover:hover{
  color: #073482!important;
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
        sure: false,
        numerosure: '',
        edit: false,
        numeroedit: '',
        document_preview: 0
      };
    },
    methods: {
      el_sure(num){
        if(this.sure){
          this.sure = false;
        }
        else{
          this.sure = true;
        }
        this.numerosure = num;
      },
      delete_draft(num){
        axios.post('/dashboard/delete-draft.php', {
            unique_id: this.propsdata[0].documents[num].unique_id
          })
          this.propsdata[0].documents.splice(num, 1);
          if(this.propsdata[0].documents.length === 0){
            this.propsdata[0].documents = null;
          }
          this.sure = false;
          this.numerosure = '';
      },
      lapicito(num){
        if(this.edit){
          this.edit = false;
        }
        else{
          this.edit = true;
        }
        this.numeroedit = num;
      },
      hide(){
        this.edit = false;
        if(this.propsdata[0].documents[this.numeroedit].titulo == ''){
          this.propsdata[0].documents[this.numeroedit].titulo = 'Untitled';
        }
        this.numeroedit = '';
      },
      edittitulo(num){
        axios.post('/dashboard/edit-titulo.php', {
            unique_id: this.propsdata[0].documents[num].unique_id,
            titulo: this.propsdata[0].documents[num].titulo
          })
      },
      document_number(num){
        this.document_preview = num;
      }
    },
    mounted() {
      this.$emit('toggle_dropdowns', 3, 'no_cerrar');
      this.$emit('updateprops');
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/divorce-settlement-agreement.vue